import React, { useState } from 'react';
import Dwolla from '../Dwolla';
import LegacyBankAccountChooser from '../LegacyBankAccountChooser';
import NameInput from './NameInput';

function ACHInput({
  processorType = 'dwolla',
  submit,
  firstName: _firstName,
  lastName: _lastName,
  email: _email,
  ...other
}) {
  const [firstName, setFirstName] = useState(_firstName);
  const [lastName, setLastName] = useState(_lastName);
  const [email, setEmail] = useState(_email);
  let content = <div />;

  if (processorType === 'dwolla' && firstName && lastName && email) {
    content = <Dwolla email={email} firstName={firstName} lastName={lastName} submit={submit} {...other} />;
  } else if (processorType === 'dwolla' && !(firstName && lastName && email)) {
    content = <NameInput firstName={firstName} lastName={lastName} email={email} {...other} submit={({
      firstName, lastName, email,
    }) => {
      setLastName(lastName);
      setFirstName(firstName);
      setEmail(email);
    }} />;
  } else if (processorType === 'legacy') {
    content = <LegacyBankAccountChooser submit={submit} />;
  }
  return content;
}

export default ACHInput;